var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contaier"},[_c('div',{staticClass:"box md:flex md:justify-between"},[_c('p',[_vm._v("Inquiry：2760 9933")]),_c('p',[_vm._v("Copyright© 2025 Kia Hong Kong. All Rights Reserved.")])])])
}]

export { render, staticRenderFns }